window.addEventListener("DOMContentLoaded", () => {
    window.startDatatables = function startDatatables(config) {
        const setDatatables = $("#setDatatables");
        const modalCall = $('#modalEdit');
        const modalShow = $('#modalShow');
        const subTitleModal = $('#sub_title_modal');

        if (!setDatatables.length) {
            return; // Saia da função se o elemento não existir
        }

        const materialDatatables = $(".materialDatatables");

        materialDatatables.css('display', 'block');

        const table = setDatatables.DataTable({
            responsive: true,
            dom: `<'row'<'col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10'r>><'row'<'col-xl-5 col-lg-5 col-md-5 col-sm-5 col-11'l>
            <'col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 col-11 text-right'f>>' +<'row'<'col-sm-12'B>><'row'<'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12't>><'row'<'col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12'i><'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'p>>`,
            buttons: [],
            language: {
                url: "/js/jquery-datatables-pt-br.json",
            },
            lengthMenu: [
                [15, 25, 50, 100, -1],
                [15, 25, 50, 100, "Todos"],
            ],
        });

        table.order([0, "desc"]);
        table.on("click", ".remove", handleDeleteConfirmation);
        table.on('click', '.modalEdit', handleModalEdit);
        table.on('click', '.modalShow', handleModalEdit);

        function handleDeleteConfirmation(e) {
            const $deleteButton = $(e.currentTarget);
            const name = $deleteButton.data('name');

            Swal.fire({
                title: `Você está tentando deletar (${name}), tem certeza de que deseja excluir? `,
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger",
                cancelButtonClass: "btn btn-",
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const $tr = $deleteButton.closest("tr");
                        const id = $deleteButton.data('id');
                        const url = $deleteButton.data('url-remove');

                        const response = await $.ajax({
                            method: "DELETE",
                            url: url,
                            dataType: "JSON",
                            data: {
                                id: id,
                            },
                        });

                        if (!response.data) {
                            Swal.fire({
                                title: `Não foi possível excluir (${name})!`,
                                icon: "error",
                                text: response.message,
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false,
                            });
                            return;
                        }

                        table.row($tr).remove().draw();
                        Swal.fire({
                            title: "Excluído com sucesso",
                            icon: "success",
                            confirmButtonClass: "btn btn-success",
                            buttonsStyling: false,
                            timer: 3000,
                        });
                    } catch (error) {
                        handleDataTablesError(error);
                    }
                }
            });
        }

        async function handleModalEdit() {
            const modalTitle = $(this).data('name');
            const url = $(this).data('url-modal');

            if (!url) {
                return; // Exit the function if url-modal doesn't exist
            }

            subTitleModal.text(modalTitle);

            modalCall.modal({
                backdrop: 'static',
                keyboard: false
            });

            try {
                const html = await $.get(url);
                modalCall.find('.modal-body').empty().append(html);
                modalCall.modal('show');
                if (config?.setScript) {
                    config.setScript();
                }
            } catch (error) {
                handleDataTablesError(error);
            }
        }

        function handleDataTablesError(error) {
            const response = error?.responseJSON;

            let title = "Ocorreu uma falha";
            if (response?.exception) {
                title = "Ocorreu uma falha";
            } else if (response?.errors && response?.message) {
                title = response.message;
            }

            Swal.fire({
                title: title,
                icon: "error",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
            });
        }

    }
});
